import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => (
  <header>
    <h1>Math Magicians</h1>
    <nav>
      <ul>
        <li>
          <NavLink to="/">Home    </NavLink>
        </li>
        <li>
          <NavLink to="/calculator">Calculator </NavLink>
        </li>
        <li>
          <NavLink to="/quote">Quote </NavLink>
        </li>
      </ul>
    </nav>
  </header>
);

export default Navbar;
